module.exports = __webpack_public_path__ + "img/diamondbank.34d5e5be.png";